import { render, staticRenderFns } from "./ZohoSalesOrdersSection.vue?vue&type=template&id=50c56b9e&scoped=true"
import script from "./ZohoSalesOrdersSection.vue?vue&type=script&lang=js"
export * from "./ZohoSalesOrdersSection.vue?vue&type=script&lang=js"
import style0 from "./ZohoSalesOrdersSection.vue?vue&type=style&index=0&id=50c56b9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c56b9e",
  null
  
)

export default component.exports